import React, { useEffect, useState, Fragment} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Card, Container, Row, Col, Form, Button} from 'react-bootstrap'
import {useFormik} from 'formik'
import { validationSchemas } from '../../common/validation-Schemas-informe-honorarios'
import { obtenerInformesPrevios, generarInforme} from '../../store/actions/informe-honorarios-action'
import { Auth, LoadingComponent } from 'recupero-comunes'

const FiltrosInformeHonorarios = () => {
    const [loading, setLoading]=useState(false)
    const data_informes = useSelector((state) => state.informeHonorariosReducer)
    const { cfg_formInf, origenesHonorarios, situaciones, responsables, criteriosFecha, respuestaGenerar} = data_informes
    const {rutUsuario, rutOrganizacion} = Auth.currentUser()
    const dispatch = useDispatch()
    
    const [isDias, setIsDias]=useState(false)
    const [isFechas, setIsfechas]=useState(false)

    const TIPO_INFORME_HONORARIOS = 999999;

    const formik = useFormik({
        initialValues: {
            "rutcia": '',
            "rutusr":'',
            "tipoInforme": '',
            "origenHonorario": '',
            "responsable": '',
            "situacion": '', 
            "fechadesde": '',
            "fechahasta": '', 
            "criterioFecha": ''
        },
        validationSchema: validationSchemas(isDias, isFechas),
        onSubmit: (formData) => {
            setLoading(true)
            const dataForm = {};// {...formData}

            dataForm['rutcia'] = rutOrganizacion && rutOrganizacion
            dataForm['rutusr'] = rutUsuario && rutUsuario     
            dataForm['tipoInforme'] = {id: TIPO_INFORME_HONORARIOS, glosa:'Informe de Honorarios'}; //Fictisio para servicio que orquesta informes
            dataForm['origenHonorario'] = formData.origenHonorario ? {id: formData.origenHonorario, glosa: origenesHonorarios.find(element => element.id == formData.origenHonorario).nombre} : {};       
            dataForm['responsable'] = formData.responsable ? {id: formData.responsable, glosa: responsables.find(element => element.id == formData.responsable).nombre} : {};       
            dataForm['situacion'] = formData.situacion ? {id: formData.situacion, glosa: situaciones.find(element => element.id == formData.situacion).nombre} : {};       
            dataForm['fechadesde'] = formData.fechadesde;
            dataForm['fechahasta'] = formData.fechahasta;
            dataForm['criteriosFecha'] = formData.criterioFecha ? {id: formData.criterioFecha, glosa: criteriosFecha.find(element => element.id == formData.criterioFecha).nombre} : {};       
           
            //console.log("dataForm: ", dataForm);
            try {
                dispatch(generarInforme(dataForm))
                .then(() => {
                    let query = Buffer.from(JSON.stringify({'rutcia': rutOrganizacion && rutOrganizacion, 'rutusr': rutUsuario && rutUsuario})).toString('base64')  
                    dispatch(obtenerInformesPrevios(query));
                })
                .then(()=>setLoading(false))
            } catch (error) {
                setLoading(false)
                console.log("error: ", error);
            }
        }
    })
    const handleLimpliar=()=>{
        formik.resetForm();
        setIsDias(false);
        setIsfechas(false);
    }
    useEffect(() => {
        let excel = respuestaGenerar && respuestaGenerar.respuestaGenerar.object;
        console.log("excel: ", excel);
        if (excel) {

            setLoading(false);
            
            var link = document.createElement("a");
            link.download = excel.filename;
            link.href = "data:" + excel.mimetype + ";base64," + excel.xlsxfile;
            link.click();
        }

    }, [respuestaGenerar]);
    return (      
    <>
      <style type='text/css'>
        {`
        .btn-limpiar {
            background-color: #F0AD3E;
            color: #FFFFFF;
            width: 140px;
            
        }
        .btn-buscar {
            background-color: #C14B49;
            color: #FFFFFF;
            width: 140px;
            padding:6px 0px 6px 0px;
      
          }
        `}
        </style>
        <LoadingComponent show={loading}/>
        <Form onSubmit={formik.handleSubmit}>
        <Container>
            <Container>            
            {cfg_formInf? (
                <div >                  
                    <Row >                 
                        <Col md='4'>
                            <Form.Label className='mb-2 mt-2'style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                {cfg_formInf.cfg_formInf && cfg_formInf.cfg_formInf['informe-hono-filtro-origen'] ? cfg_formInf.cfg_formInf['informe-hono-filtro-origen'] : "Origen Honorario"}
                            </Form.Label>{' '}
                            <br />
                            <Form.Select
                                className='mt-2'
                                aria-label='Default select example'
                                onChange={(e) => {
                                    formik.handleChange(e)
                                }}
                                name='origenHonorario'
                                value={(formik.values.origenHonorario)}
                                error={formik.errors.origenHonorario}
                            >
                            <option value={''}>Seleccione...</option>
                            {origenesHonorarios &&
                                origenesHonorarios?.map((c) => (
                                    <option key={c.id} value={c.id}>{c.nombre}</option>
                                ))
                            }
                            </Form.Select>
                            {formik.errors.origenHonorario ? (
                                <Form.Text variant='danger' style={{ color: 'red' }}>
                                    {formik.errors.origenHonorario}
                                </Form.Text>
                            ) : (
                                ''
                            )} 
                        </Col>  
                        <Col md='4'>
                            <Form.Label className='mb-2 mt-2'style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                {cfg_formInf.cfg_formInf && cfg_formInf.cfg_formInf['informe-hono-filtro-responsable'] ? cfg_formInf.cfg_formInf['informe-hono-filtro-responsable'] : "Responsable Solicitud"}
                            </Form.Label>{' '}
                            <br />
                            <Form.Select
                                className='mt-2'
                                aria-label='Default select example'
                                onChange={(e) => {
                                    formik.handleChange(e)

                                }}
                                name='responsable'
                                value={(formik.values.responsable)}
                                error={formik.errors.responsable}
                            >
                            <option value={''}>Seleccione...</option>
                            {responsables &&
                                responsables?.map((c) => (
                                    <option key={c.id} value={c.id}>{c.nombre}</option>
                                ))
                            }
                            </Form.Select>
                            {formik.errors.responsable ? (
                                <Form.Text variant='danger' style={{ color: 'red' }}>
                                    {formik.errors.responsable}
                                </Form.Text>
                            ) : (
                                ''
                            )} 
                        </Col>     
                    </Row>
                    <Row >                 
                        <Col md='3'>
                            <Form.Label className='mb-2 mt-4'style={{ fontWeight: 'bold', fontSize: '14px' }}>                            
                                {cfg_formInf.cfg_formInf && cfg_formInf.cfg_formInf['informe-hono-filtro-situacion'] ? cfg_formInf.cfg_formInf['informe-hono-filtro-situacion'] : "Situación"}
                            </Form.Label>{' '}
                            <br />
                            <Form.Select                            
                                onChange={(e) => {
                                    formik.handleChange(e)
                                }}
                                name='situacion'
                                value={(formik.values.situacion)}
                                error={formik.errors.situacion}
                            >
                            <option value={''}>Seleccione...</option>
                            {situaciones && situaciones
                                ?.map((c) => (
                                    <option key={c.id} value={c.id}>{c.nombre}</option>
                                ))
                            }
                            </Form.Select>
                            {formik.errors.situacion ? (
                                <Form.Text variant='danger' style={{ color: 'red' }}>
                                    {formik.errors.situacion}
                                </Form.Text>
                            ) : (
                                ''
                            )} 
                        </Col>
                        <Col md='2'>
                            <Form.Label className='mb-2 mt-4' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                {cfg_formInf.cfg_formInf && cfg_formInf.cfg_formInf['informe-hono-filtro-fechadesde'] ? cfg_formInf.cfg_formInf['informe-hono-filtro-fechadesde'] : "Fecha Desde"}
                            </Form.Label>{' '}
                            <br />                   
                            <Form.Control type='date'
                                name='fechadesde'
                                value={formik.values.fechadesde}
                                onChange={(e)=>{
                                    formik.handleChange(e);     
                                    setIsfechas(true);  
                                }}
                            ></Form.Control>   
                            {formik.errors.fechadesde ? (
                                <Form.Text variant='danger' style={{ color: 'red' }}>
                                    {formik.errors.fechadesde}
                                </Form.Text>
                            ) : (
                                ''
                            )}              
                        </Col>
                        <Col md='2' >
                            <Form.Label className='mb-2 mt-4' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                {cfg_formInf.cfg_formInf && cfg_formInf.cfg_formInf['informe-hono-filtro-fechahasta'] ? cfg_formInf.cfg_formInf['informe-hono-filtro-fechahasta'] : "Fecha Hasta"}
                            </Form.Label>{' '}
                            <br />
                            <Form.Control type='date'
                                name='fechahasta'
                                value={formik.values.fechahasta}
                                onChange={(e)=>{
                                    formik.handleChange(e)
                                    setIsfechas(true);  
                                }}
                            ></Form.Control>
                            {formik.errors.fechahasta ? (
                                <Form.Text variant='danger' style={{ color: 'red' }}>
                                    {formik.errors.fechahasta}
                                </Form.Text>
                            ) : (
                                ''
                            )} 
                        </Col>
                        <Col md='3'>
                            <Form.Label className='mb-2 mt-4'style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                {cfg_formInf.cfg_formInf && cfg_formInf.cfg_formInf['informe-hono-filtro-criterio'] ? cfg_formInf.cfg_formInf['informe-hono-filtro-criterio'] : "Criterio Fecha"}
                            </Form.Label>{' '}
                            <br />
                            <Form.Select
                                onChange={(e) => {
                                    formik.handleChange(e)
                                    setIsfechas(true);  
                                }}
                                name='criterioFecha'
                                value={(formik.values.criterioFecha)}
                                error={formik.errors.criterioFecha}
                            >
                            <option value={''}>Seleccione...</option>
                            {criteriosFecha && criteriosFecha
                                ?.filter(p => (p.agrupacion == 0 || p.agrupacion == tipoGestion))
                                ?.map((c) => (
                                    <option key={c.id} value={c.id}>{c.nombre}</option>
                                ))
                            }
                            </Form.Select>
                            {formik.errors.criterioFecha ? (
                                <Form.Text variant='danger' style={{ color: 'red' }}>
                                    {formik.errors.criterioFecha}
                                </Form.Text>
                            ) : (
                                ''
                            )} 
                        </Col>
                
                    </Row>
                    <hr style={{ color: '#04005D', height: '2px', marginTop:'30px' }}></hr>
                        <Row className='mt-2'>                            
                            <Col className='d-flex align-items-end justify-content-end m-2'>
                                <Button className='m-2' variant='limpiar' onClick={handleLimpliar}  >
                                    {cfg_formInf.cfg_formInf && cfg_formInf.cfg_formInf['informe-hono-btn-limpiar'] ? cfg_formInf.cfg_formInf["informe-hono-btn-limpiar"] : "Limpiar"}
                                </Button>
                                <Button className='m-2' variant='buscar' type='onSubmit' >
                                    {cfg_formInf.cfg_formInf && cfg_formInf.cfg_formInf['informe-hono-btn-gen-informe'] ? cfg_formInf.cfg_formInf["informe-hono-btn-gen-informe"] : "Generar Informe"}
                                </Button>                            
                            </Col>
                        </Row>
                    </div>
                ) : ""}
                </Container>
            </Container>
            </Form>
        </>
    )
}
export default FiltrosInformeHonorarios 